import script from "./AutofillFromDocumentsComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./AutofillFromDocumentsComponent.vue?vue&type=script&setup=true&lang=js"

import "./AutofillFromDocumentsComponent.vue?vue&type=style&index=0&id=01197e14&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01197e14"]])

export default __exports__